import { inferRouteObject } from 'react-router-typed-object';

import { CampaignPositionStatus } from '@/services/ws-print-operations/src/main/resources/rest-api';
import { Navigate } from '@/js/libs/router';
import { PrivateRoute, Roles } from '@/js/libs/use-auth';

import RouteParamsValidator from 'src/components/RouteParamsValidator';
import PrintOperations from 'src/scenes/PrintOperations';
import { validatePrintOperationStatus } from 'src/scenes/PrintOperations/helpers';
import Status from 'src/scenes/Status';

const index = true;

export const printOperationsRouteObject = inferRouteObject({
  path: 'print-operations',
  element: <PrivateRoute roles={Roles.MANAGE_PRINT_PRODUCTS} noAccessComponent={Status.NotFound} />,
  children: [
    {
      Component: PrintOperations.Helmet,
      children: [
        {
          path: 'print',
          children: [
            {
              path: ':status',
              element: <RouteParamsValidator validate={validatePrintOperationStatus} invalidStateElement={<Status.NotFound />} />,
              children: [{ index, Component: PrintOperations.Print }],
            },
            {
              path: 'PHYSICAL_PROOFS',
              Component: PrintOperations.PhysicalProofs,
            },
            {
              index,
              element: <Navigate to={`./${CampaignPositionStatus.READY_TO_PUSH}`} replace />,
            },
          ],
        },
        {
          path: 'extracted-labels',
          Component: PrintOperations.ExtractedLabels,
        },
        {
          path: 'publication-upload',
          Component: PrintOperations.PublicationUpload,
        },
        {
          index,
          element: <Navigate to={`./print/${CampaignPositionStatus.READY_TO_PUSH}`} replace />,
        },
      ],
    },
  ],
});
